
import React from 'react';
import { Member, MemberRole } from '../types/memberTypes';
import MemberMobileItem from './MemberMobileItem';

interface MemberMobileListProps {
  members: Member[];
  editingMemberId: string | null;
  isCurrentMemberPrimaryOwner: boolean;
  getCheckedPermissionsCount: (permissions?: any[]) => number;
  getCheckedPermissionNames: (permissions?: any[]) => string[];
  handleRemoveMemberClick: (member: Member) => void;
  handleEditClick: (memberId: string) => void;
  handleCancelEdit: () => void;
  handleSaveEdit: () => void;
  handleRoleChange: (memberId: string, role: MemberRole) => void;
  handlePermissionChange: (memberId: string, permissionId: string, checked: boolean) => void;
  canManageBusinessMembers: boolean;
  handleResendInvite?: (member: Member) => void;
}

const MemberMobileList: React.FC<MemberMobileListProps> = ({
  members,
  editingMemberId,
  isCurrentMemberPrimaryOwner,
  getCheckedPermissionsCount,
  getCheckedPermissionNames,
  handleRemoveMemberClick,
  handleEditClick,
  handleCancelEdit,
  handleSaveEdit,
  handleRoleChange,
  handlePermissionChange,
  canManageBusinessMembers,
  handleResendInvite
}) => {
  // Find the current member to check permissions
  const currentMember = members.find(member => member.isCurrentUser);
  
  // Check if the current member has the required permissions
  const hasPortfolioMembersPermission = currentMember?.permissions?.some(p => 
    p.id === 'portfolioUsers' && p.checked
  ) || false;
  
  const hasPortfolioSettingsPermission = currentMember?.permissions?.some(p => 
    p.id === 'portfolioSettings' && p.checked
  ) || false;
  
  // Member can edit/delete if they have both required permissions OR they're an Owner/Primary Owner
  const canManageMembers = (hasPortfolioMembersPermission && hasPortfolioSettingsPermission) || 
                          currentMember?.role === 'Primary Owner' || 
                          currentMember?.role === 'Owner';
  
  return (
    <div className="space-y-4">
      {members.map((member) => (
        <MemberMobileItem
          key={member.id}
          member={member}
          editingMemberId={editingMemberId}
          isCurrentMemberPrimaryOwner={isCurrentMemberPrimaryOwner}
          getCheckedPermissionsCount={getCheckedPermissionsCount}
          getCheckedPermissionNames={getCheckedPermissionNames}
          handleRemoveMemberClick={handleRemoveMemberClick}
          handleEditClick={handleEditClick}
          handleCancelEdit={handleCancelEdit}
          handleSaveEdit={handleSaveEdit}
          handleRoleChange={handleRoleChange}
          handlePermissionChange={handlePermissionChange}
          canManageBusinessMembers={canManageMembers}
          handleResendInvite={handleResendInvite}
        />
      ))}
    </div>
  );
};

export default MemberMobileList;
